module.exports = __webpack_public_path__ + "img/spinner-white.da0c6413.svg";